module.exports = __webpack_public_path__ + "static/media/fig_29c.ef68ecd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_29c.jpg
// module id = 670
// module chunks = 0